var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "not-found" } },
    [
      _c("div", { staticClass: "head" }, [
        _c("h1", [_vm._v(" What have you done? ")]),
        _c("h5", [_vm._v(" Now Go Back Using Below LInk ")]),
        _c(
          "span",
          { staticClass: "status-code" },
          [
            _c("ICountUp", {
              attrs: {
                startVal: _vm.startVal,
                endVal: _vm.endVal,
                decimals: _vm.decimals,
                duration: _vm.duration,
                options: _vm.options,
              },
              on: { ready: _vm.onReady },
            }),
          ],
          1
        ),
        _c("h2", [_vm._v("! ERROR DECETED !")]),
      ]),
      _c(
        "h3",
        { staticClass: "icon" },
        [_c("Icon", { attrs: { type: "md-bulb", size: "112" } })],
        1
      ),
      _c("Button", { attrs: { type: "primary" } }, [
        _c(
          "a",
          {
            staticStyle: { color: "#fff" },
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.$store.commit("MENU_SELECT", "/")
              },
            },
          },
          [_vm._v("GO TO HOME PAGE")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }